// Utility function to validate email
function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

document.addEventListener('DOMContentLoaded', function () {
    // Handle dimmed effect for #recover
    if (window.location.hash === '#recover') {
        document.body.classList.add('dimmed');
    }

    window.addEventListener('hashchange', function () {
        if (window.location.hash === '#recover') {
            document.body.classList.add('dimmed');
        } else {
            document.body.classList.remove('dimmed');
        }
    });

    function toggleSubmitButton(isSending = false) {
        const signInButton = document.getElementById('signInButton');
        if (isSending) {
            signInButton.disabled = true;
        } else {
            signInButton.disabled = false;
        }
    }

    // Function to handle login
    function submitLogin() {
        const loginForm = document.getElementById("customer_login");
        const formData = new FormData(loginForm);
        const formAction = loginForm.getAttribute("action");
        const formMethod = loginForm.getAttribute("method");

        fetch(formAction, {
            method: formMethod,
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            if (response.ok && response.status === 200) {
                return response.text();
            }
        }).then(response => {
            if (response.includes('Incorrect email or password.')) {
                console.log('User logging wrong');
                document.querySelector('.form__message-error').style.display = 'block';
            } else {
                console.log('User logged in successfully');
                window.location.href = "/pages/orders";
            }
            toggleSubmitButton();
        }).catch(error => console.error('Error:', error));
    }

    // Handle login form submission
    document.getElementById('customer_login').addEventListener('submit', function (event) {
        event.preventDefault();
        const emailInput = document.getElementById('CustomerEmail');
        const passwordInput = document.getElementById('CustomerPassword');
        const email = emailInput.value;
        const password = passwordInput.value;
        let isValid = true;

        if (!email) {
            isValid = false;
            const emailError = document.createElement('div');
            emailError.id = 'login-email-error';
            emailError.className = 'mage-error';
            emailError.textContent = 'It is a required field.';
            emailInput.classList.add('input-text', 'mage-error');
            emailInput.setAttribute('aria-invalid', 'true');
            emailInput.setAttribute('aria-describedby', 'login-email-error');
            emailInput.insertAdjacentElement('afterend', emailError);
        }

        // Validate password field
        if (!password) {
            isValid = false;
            const passwordError = document.createElement('div');
            passwordError.id = 'login-password-error';
            passwordError.className = 'mage-error';
            passwordError.textContent = 'It is a required field.';
            passwordInput.classList.add('input-text', 'mage-error');
            passwordInput.setAttribute('aria-invalid', 'true');
            passwordInput.setAttribute('aria-describedby', 'login-password-error');
            passwordInput.insertAdjacentElement('afterend', passwordError);
        }

        // If both fields are valid, proceed with the form submission
        if (isValid) {
            toggleSubmitButton(true);
            fetch(window.subscriptionEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({action: 'check-email', email: email})
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            }).then(data => {
                const messageElement = document.createElement('div');
                messageElement.id = 'api-response-message';

                const errorMessageElement = document.getElementById('error_account-active');
                const errorMessageTitle = document.getElementById('message-error-title');
                const existingMessageElement = document.getElementById('api-response-message');
                if (existingMessageElement) {
                    existingMessageElement.remove();
                }

                if (data.has_account) {
                    const tags = data.customer.tags;
                    if (data.account_activate) {
                        return submitLogin();
                    }else if (tags?.includes('newsletter')) {
                        document.querySelectorAll('.form__message.error-message-container').forEach((element) => {
                        element.classList.add('active');
                        });
                        errorMessageTitle.classList.remove('active');
                        messageElement.innerText = window.loginFormStrings.no_have_account;
                        errorMessageElement.appendChild(messageElement);
                    } else {
                        messageElement.innerHTML = window.loginFormStrings.reset_password_message;
                        errorMessageTitle.classList.add('active');
                        errorMessageTitle.innerHTML = data.message_title;
                        errorMessageElement.appendChild(messageElement);
                        document.querySelectorAll('.form__message.error-message-container').forEach((element) => {
                        element.classList.add('active');
                        });

                        document.getElementById('send-activation-email').addEventListener('click', function (event) {
                            if (!event.detail || event.detail === 1) {
                                event.preventDefault();
                                fetch(window.subscriptionEndpoint, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({action: 'send-activation-email', email: email})
                                }).then(response => {
                                    if (!response.ok) {
                                        throw new Error('Network response was not ok ' + response.statusText);
                                    }
                                    return response.json();
                                }).then(data => {
                                    console.log(data.message);
                                    alert(window.loginFormStrings.activation_sent);
                                }).catch(error => console.error('Error:', error));
                            }
                        });
                    }
                } else {
                    document.querySelector('.form__message-error').style.display = 'block';
                }
                toggleSubmitButton();
            }).catch(error => console.error('Error:', error));
        }
    });

    // // Toggle between login and guest tabs
    // const signInTab = document.querySelector('.block-tabs.mobile ul li.sign-in');
    // const guestTab = document.querySelector('.block-tabs.mobile ul li.guest');
    // const loginLeft = document.querySelector('.login-left');
    // const loginRight = document.querySelector('.login-right');
    //
    // //signInTab.classList.add('active');
    // guestTab.classList.remove('active');
    //
    // signInTab.addEventListener('click', function() {
    //   loginLeft.style.display = 'block';
    //   loginRight.style.display = 'none';
    //   signInTab.classList.add('active');
    //   guestTab.classList.remove('active');
    // });
    //
    // guestTab.addEventListener('click', function() {
    //   loginLeft.style.display = 'none';
    //   loginRight.style.display = 'block';
    //   signInTab.classList.remove('active');
    //   guestTab.classList.add('active');
    // });

    // Handle password recovery
    const recoverForm = document.querySelector('.login-page-forgot form');
    const recoverButton = document.getElementById('RecoverPasswordButton');
    const emailInput = document.getElementById('RecoverEmail');

    recoverForm.addEventListener('submit', function (event) {
        recoverButton.disabled = true;

        // const formData = new FormData(recoverForm);
        const email = emailInput.value;

        if (!isValidEmail(email)) {
            event.preventDefault();
            const msg = $(event.target).find('small');
            recoverForm.querySelector(".field").classList.add("error")
            msg.children('span').text('It Is A Required Field.');
            msg.show();
            recoverButton.disabled = false;
            return;
        }

        // fetch(recoverForm.action, {
        //     method: 'POST',
        //     body: formData,
        //     headers: {
        //         'Accept': 'application/json'
        //     }
        // }).then(response => {
        //     recoverButton.innerHTML = 'SUBMIT';
        //     recoverButton.disabled = true;
        //     if (response.ok && response.status === 200) {
        //         return response.text().then(text => {
        //             if (text.includes('sent you an email with')) {
        //                 console.log('Recovery email sent successfully.');
        //                 const successMessage = document.querySelector('.message-success div');
        //                 successMessage.innerHTML = successMessage.innerHTML.replace('hoan@itsforce.com', email);
        //                 document.querySelector('.message-success.success').style.display = 'block';
        //             } else {
        //                 console.log('Recovery failed. Email not found.');
        //             }
        //         });
        //     }
        // }).catch(error => console.error('Error:', error));
    });
});
  